<template>
  <div class="wrapper webindex-mac">
    <div class="headerContainer">
      <div class="top-background"></div>
      <!-- <Header></Header> -->
      <header class="header">
        <div class="center">
          <div class="header-center-div">
            <h1 class="header-center-h1">智能改变生活</h1>
            <div class="header-center-line"></div>
            <p class="header-center-p">专注提供一站式智能化解决方案</p>
          </div>
        </div>
        <div class="bottom-container">
          <div class="bottom">
            <div class="header-bottom-div">
              <div class="bottom-div-title">
                <div class="bottom-title-div">
                  <div class="bottom-div-title1">
                    <h1>{{ industryYears }}</h1>
                    <span class="yearText">年</span>
                  </div>
                  <div class="bottom-div-title2">行业经验</div>
                </div>
              </div>
              <div class="bottom-div-title">
                <div class="bottom-title-div">
                  <div class="bottom-div-title1">
                    <h1>40</h1>
                    <span>+</span>
                  </div>
                  <div class="bottom-div-title2">城市覆盖</div>
                </div>
              </div>
              <div class="bottom-div-title">
                <div class="bottom-title-div">
                  <div class="bottom-div-title1">
                    <h1 @click="test">60</h1>
                    <span>+</span>
                  </div>
                  <div class="bottom-div-title2">战略伙伴</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>

    <div class="container">
      <div class="content">
        <div class="content-main1">
          <h1 class="content-main1-background">ABOUT-US</h1>
          <h3 class="content-main1-title">关于昌恩智能</h3>
          <p class="content-main1-p">
            公司成立于1998年5月22日，是经广东省公安厅、广东省住建厅批准认证、在建设“智慧城市”背景下为客户提供智能化整体解决方案的综合性企业。公司目前以建筑智能化、智能交通为主营业务。
          </p>
          <div class="content-main1-br"></div>
          <div class="content-main1-div">
            <div class="content-main1-hexagon">
              <router-link :to="{ path: '/introduction' }">
                <img
                  class="img1"
                  src="../assets/img/icon-jtjs.svg"
                  alt=""
                  srcset=""
                />
                <p>集团介绍</p>
              </router-link>
            </div>
            <div class="content-main1-hexagon">
              <router-link :to="{ path: '/projects' }">
                <img
                  class="img1"
                  src="../assets/img/icon-alzs.svg"
                  alt=""
                  srcset=""
                />
                <p>案例展示</p>
              </router-link>
            </div>
            <div class="content-main1-hexagon">
              <router-link :to="{ path: '/qualification' }">
                <img
                  class="img2"
                  src="../assets/img/icon-zzzx.svg"
                  alt=""
                  srcset=""
                />
                <p>资质中心</p>
              </router-link>
            </div>
            <div class="content-main1-hexagon">
              <router-link :to="{ path: '/ceo' }">
                <img
                  class="img3"
                  src="../assets/img/icon-dszzc.svg"
                  alt=""
                  srcset=""
                />
                <p>董事长致辞</p>
              </router-link>
            </div>
          </div>
        </div>

        <div class="content-main2">
          <div class="leftbgc"></div>
          <div class="content-main2-content">
            <h2 class="content-main2-title">主营业务</h2>
            <div class="work">
              <div class="content-main2-right">
                <div class="content-main2-right-div">
                  <img
                    class="content-main2-right-img"
                    src="../assets/img/index/homepage1.jpg"
                    alt=""
                  />
                  <div class="content-main2-right-title">城市与建筑智能化</div>
                  <p class="content-main2-right-p">
                    城市与建筑智能化服务领域遍及政府机构、金融行业、教育、医疗、公安边防、文博系统、旅游景点等。
                  </p>
                  <router-link :to="{ path: '/buliding' }">
                    <button class="content-main2-right-button">
                      <span>查看更多</span>
                      <img src="../assets/img/icon_more.svg" alt="" />
                    </button>
                  </router-link>
                </div>
                <div class="content-main2-right-div">
                  <img
                    class="content-main2-right-img"
                    src="../assets/img/index/homepage2.jpg"
                    alt=""
                  />
                  <div class="content-main2-right-title">智能交通</div>
                  <p class="content-main2-right-p">
                    智能交通业务涉及出租车、网约车、两客一危及车辆运营监管平台与终端等。
                  </p>
                  <router-link :to="{ path: '/traffic' }">
                    <button class="content-main2-right-button">
                      <span>查看更多</span>
                      <img src="../assets/img/icon_more.svg" alt="" />
                    </button>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="content-main3 main3-mac">
          <div class="content-main3-background2"></div>
          <div class="content-main3-content main3-conten-mac">
            <div class="content-main3-left">
              <h2 class="content-main3-title">新闻中心</h2>
              <div class="content-main3-nav">
                <p
                  :class="currentIndex == index ? 'active' : ''"
                  v-for="(item, index) in list"
                  :key="item.id"
                  @click="change(index)"
                >
                  {{ item.title }}
                </p>
              </div>
              <!-- 占位 -->
              <div v-if="!one" style="height: 680px">
                <p
                  style="
                    padding-top: 100px;
                    text-align: center;
                    font-size: 16px;
                    color: #999;
                  "
                >
                  暂无数据~
                </p>
              </div>
              <!--  -->
              <div class="content-main3-left-div" v-if="one">
                <img :src="this.imgPath || defaultImg" id="img" class="img" />
                <router-link
                  :to="{
                    path: '/newsdetailed/',
                    query: { id: `${this.one.resourceId}` }
                  }"
                  class="main3-news"
                >
                  <div class="main3-news-date">
                    <div v-if="this.one.createTime">
                      <h1>{{ this.one.createTime.slice(8, 10) }}</h1>
                      <div>
                        <p>{{ this.one.createTime.slice(0, 7) }}</p>
                        <div class="bottom-line"></div>
                      </div>
                    </div>
                  </div>
                  <div class="main3-news-title">
                    <h3>{{ this.one.title }}</h3>
                    <p v-if="this.one.limitContent" class="oneContent">
                      {{ this.one.limitContent.replace(this.regex, '') }}
                    </p>
                    <!-- <p class="oneContent">
                      党建引领促发展，联学联建共提升｜深圳市智慧安防行业协会专家委
                      “走进昌恩智能”党建交流活动成功举行
                    </p> -->
                  </div>
                </router-link>
              </div>
            </div>

            <div class="content-main3-right content-main3-right-mac">
              <div
                v-for="person in newarr"
                :key="person.resourceId"
                class="newslist-container"
              >
                <div v-if="one">
                  <router-link
                    :to="{
                      path: '/newsdetailed/',
                      query: { id: `${person.resourceId}` }
                    }"
                    class="main3-news"
                  >
                    <div class="main3-news-date">
                      <div>
                        <h1>{{ person.createTime.slice(8, 10) }}</h1>
                        <div>
                          <p>{{ person.createTime.slice(0, 7) }}</p>
                          <div class="bottom-line"></div>
                        </div>
                      </div>
                    </div>
                    <div class="main3-news-title">
                      <h3>{{ person.title }}</h3>
                      <p v-if="person.limitContent">
                        {{ person.limitContent }}
                      </p>
                    </div>
                  </router-link>
                </div>
              </div>
              <!-- 占位 -->
              <div
                v-if="newarr.length < 4 && newarr.length < 3"
                class="newslist-container"
              >
                <div style="height: 170px">
                  <h1></h1>
                  <p></p>
                  <pre>
                    <div></div>
                  </pre>
                </div>
              </div>
              <!-- 占位 -->
              <div
                v-if="newarr.length < 4 && newarr.length > 2"
                class="newslist-container"
              >
                <div style="height: 170px">
                  <h1></h1>
                  <p></p>
                  <div></div>
                </div>
              </div>
              <!--  -->
            </div>

            <div class="content-main3-background1">NEWS</div>
            <div class="content-main3-background3"></div>
          </div>
        </div>
      </div>
    </div>
    <Footer class="footer" />
  </div>
</template>

<script>
import Header from '../components/header.vue'
import Footer from '../components/footer.vue'
export default {
  components: { Footer, Header },
  name: 'webindex',

  data () {
    return {
      num: 1,
      category: '',
      type: 1,
      status: 1,
      one: [],
      //去除p标签
      regex: /(<([^>]+)>)/gi,
      newarr: [],
      imgPath: '',
      currentIndex: 0, //表示当前选项卡,
      list: [
        {
          id: 1, //用来代表每一个对象
          title: '最新消息', //标题
          gopath: '/webindex/news4'
        },
        {
          id: 2,
          title: '集团公告', //标题
          gopath: '/webindex/news3'
        },
        // {
        //   id: 3,
        //   title: "信息披露", //标题
        //   gopath: "/webindex/news2"
        // },
        {
          id: 4,
          title: '公司动态', //标题
          gopath: '/webindex/news'
        }
      ],
      industryYears: 0
    }
  },
  created () {},
  mounted () {
    // this.BootAnimation();
    this.select('')
    const currentYear = new Date().getFullYear()
    this.industryYears = currentYear - 1998
  },
  methods: {
    test () {
      window.location.href = 'http://www.baidu.com'
    },
    BootAnimation () {
      let v1 = sessionStorage.getItem('start')
      if (v1 == null) {
        this.$router.push({ path: '/BootAnimation' })
      }
      sessionStorage.setItem('start', 112233)
    },

    change (index) {
      //用来实现切换功能
      //实现选项卡 切换操作 - 本质就是操作类名
      // 通过currentIndex操作
      this.currentIndex = index
      var name = ''
      if (index == 0) {
        name = ''
      }
      if (index == 1) {
        name = '集团公告'
      }
      // if (index == 2) {
      //   name = "信息披露";
      // }
      if (index == 2) {
        name = '公司动态'
      }
      this.select(name)
    },

    select (name) {
      var lengs = ' 为加强公司品牌宣传工作，扩大昌恩智能在外部的知名度'
      this.request
        .get(`/${this.status}/${this.type}`, {
          params: {
            pageSize: 5,
            category: name
          }
        })
        .then(res => {
          if (res.code == 401) {
            this.$router.push({ path: '/app' })
          }
          this.one = res.data.data[0]
          this.one.content = this.getSimpleText(res.data.data[0].limitContent)
          this.imgPath = res.data.data[0].imgPath
          this.newarr = res.data.data.slice(1)
        })
    },

    sliceDay (arr) {
      return arr.slice(8, 10)
    },
    sliceYear (arr) {
      return arr.slice(0, 7)
    },
    delHtmlTag (str) {
      return str.replace(/<[^>]+>/g, '') //正则去掉所有的html标记
    },

    getSimpleText (html) {
      const re1 = new RegExp('<.+?>', 'g') // 匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
      const arrEntities = {
        lt: '<',
        gt: '>',
        nbsp: ' ',
        amp: '&',
        quot: '"',
        ldquo: '“',
        mdash: '—',
        rdquo: '”'
      }
      // 增加判断
      if (html) {
        return html
          .replace(re1, '')
          .replace(
            /&(lt|gt|nbsp|amp|quot|ldquo|mdash|rdquo);/gi,
            function (all, t) {
              return arrEntities[t]
            }
          )
      }
    }
  }
}
</script>

<style scoped>
/* .wrapper {
  position: relative;
  width: 100%;
  min-height: 100%;
  padding-bottom: 100px;
  bottom: 0px;
  left: 0px;
  box-sizing: border-box;
}

.footer {
  width: 100%;
  height: 100px !important;
  position: absolute;
  bottom: 0px;
  left: 0px;
} */

/* 缩放125% */
@media screen and (min-width: 1200px) and (max-width: 1600px) {
  /* 主营业务文字 */
  .content-main2-title {
    text-align: center !important;
    /* margin-left: -20px !important; */
  }
  .content-main2-content {
    /* width: 1400px !important;
    background-color: red !important; */
  }
  .work {
    transform: scale(0.92);
  }

  .content-main3 {
    transform: scale(0.94);
    margin-left: 0px !important;
    /* background-color: red !important; */
    height: 1360px !important;
  }
}

/* 宽度在1285 PC样式：150% */
@media screen and (max-width: 1285px) {
  .content-main3 {
    transform: scale(0.84);
    margin-left: -90px !important;
    /* background-color: red !important; */
    height: 1160px !important;
  }
  .content-main3-content {
    height: 800px !important;
  }
  /* news */
  .content-main3-background1 {
    top: 0 !important;
  }
  /* 右侧灰快 */
  .content-main3-background2 {
    width: 100% !important;
    right: -600px !important;
    top: -10px !important;
  }
  .content-main2 {
    height: 100% !important;
  }
  .work {
    transform: scale(0.82);
    margin-left: -80px !important;
    padding: 20px 0;
    /* background-color: blue !important; */
  }
  .content-main2-right {
    margin-left: -60px;
  }
  .leftbgc {
    font-size: 20px;
  }
  /* 主营业务 */
  .content-main2-title {
    font-size: 26px !important;
    z-index: 0 !important;
    margin-left: -20px !important;
  }
}

/* 缩放175% */
/* 宽度小于1200px的非PC样式（例如平板电脑和手机）： */
@media screen and (max-width: 1199px) {
  /* header */
  .header-bottom-div {
    transform: scale(0.8);
  }
  .content-main3 {
    transform: scale(0.7);
    margin-left: -140px !important;
    height: 900px !important;
  }
  .content-main3-content {
    height: 600px !important;
  }
  /* news */
  .content-main3-background1 {
    top: -100px !important;
  }
  /* 右侧灰快 */
  .content-main3-background2 {
    width: 100% !important;
    right: -600px !important;
    top: -80px !important;
    height: 1000px !important;
  }

  /* 主营业务 */
  .content-main2 .content-main2-title {
    text-align: center !important;
    z-index: 0 !important;
    padding-right: 20px !important;
  }

  .work {
    transform: scale(0.7);
    margin-left: -180px !important;
  }
  .content-main2-right {
    margin-left: -60px;
  }
  .leftbgc {
    font-size: 20px;
  }
  .content-main2 {
    height: 720px !important;
  }
}

/* 缩放200% */
/* 宽度小于1200px的非PC样式（例如平板电脑和手机）： */
@media screen and (max-width: 1000px) {
  /* header */
  .header-bottom-div {
    transform: scale(0.76);
  }
  /* 4个icon */
  .content-main1-div {
    transform: scale(0.9);
  }

  .content-main3 {
    transform: scale(0.63);
    margin-left: -168px !important;
    height: 840px !important;
  }
  .content-main1-p {
    padding: 0 20px;
  }

  /* 主营业务楼层 容器*/
  .content-main2 {
    width: 1200px !important;
    height: 640px !important;
  }
  .work {
    transform: scale(0.6);
    margin-left: -220px !important;
  }
  .content-main2-content {
  }
  .content-main2-right {
    /* margin-left: -60px; */
  }
  .leftbgc {
    font-size: 20px;
  }
  /* 主营业务 */
  .content-main2-title {
    font-size: 26px !important;
    z-index: 0 !important;
    padding-left: 38px !important;
    margin-left: -40px !important;
  }
  .leftbgc {
    width: 30% !important;
  }
}

/*250%  */
@media screen and (max-width: 900px) {
  /* 主营业务楼层 容器*/
  .content-main2 {
    width: 1100px !important;
    height: 640px !important;
  }
  .work {
    transform: scale(0.5);
    margin-left: -320px !important;
  }
  .content-main2 .content-main2-title {
    margin-left: -40px !important;
    padding-right: 60px !important;
  }
  .content-main1-title {
    width: 760px;
  }
  .content-main1-p {
    width: 760px !important;
  }
}

/*300%  */
/* @media only screen and (min-width: 1200px) and (-webkit-min-device-pixel-ratio: 3),
  only screen and (min-width: 1200px) and (min-resolution: 320dpi) { */
@media screen and (min-width: 600px) and (max-width: 700px) {
  .nav-left .logoImg {
    width: 60px !important;
  }
  .nav-left {
    transform: scale(0.8);
  }
  .content-main1-title {
    width: 640px;
  }
  .content-main1-p {
    width: 640px !important;
  }
}
.headerContainer {
  height: 720px;
}

.top-background {
  position: absolute;
  top: 0;
  width: 100%;
  height: 80px;
  background: rgba(10, 11, 21, 0.8);
  z-index: 1;
}

.header {
  position: relative;
  /* display: flex;
  justify-content: center; */
  height: 720px;
  height: 740px;
  background: url(../assets/img/start/开机banner@2x.jpg) no-repeat;
  background-size: cover;
  background-position: right;
}
.header::before {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 0;
}

.top {
  position: absolute;
  top: 0;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 80px;
  /* background-color: rgba(0, 0, 0, 0.19); */
  z-index: 999;
}

.nav {
  display: flex;
  justify-content: space-between;
  width: 1560px;
  height: 100%;
}

.nav-left {
  display: flex;
  align-items: center;
  height: 100%;
}

.nav-left img {
  width: 167px;
  height: 43px;
}

.nav-right {
  display: flex;
  align-items: center;
  height: 100%;
}

.nav-right dl {
  margin-right: 60px;
  line-height: 80px;
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  cursor: pointer;
}

.nav-right dl:last-child {
  margin-right: 0;
}

.nav-right-dl1 {
  position: relative;
}

.nav-right-dl1 img,
.nav-right-dl2 img {
  margin-left: 12px;
  transform: rotate(180deg);
  transition: all 0.3s;
}

.nav-right-dl1-box {
  visibility: hidden;
  width: 116px;
  position: absolute;
  top: 87px;
  left: -20px;
  line-height: 40px;
  background: rgba(108, 120, 155, 0.74);
  box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  opacity: 0;
  transition: all 0.3s;
  z-index: -999;
}

.nav-right-dl1-box::after {
  position: absolute;
  top: -7.1px;
  left: 50%;
  transform: translateX(-50%);
  content: '';
  width: 0;
  height: 0;
  border-bottom: 8px solid rgba(108, 120, 155, 0.74);
  border-right: 5px solid transparent;
  border-left: 5px solid transparent;
  box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.1);
}

.dl1-box-title {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  font-weight: 550;
  padding: 0 24px 0 19px;
}

.nav-right-dl2 {
  position: relative;
}

.nav-right-dl2-box {
  visibility: hidden;
  width: 200px;
  position: absolute;
  top: 87px;
  left: -60px;
  line-height: 40px;
  background: rgba(108, 120, 155, 0.74);
  box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  opacity: 0;
  transition: all 0.3s;
  z-index: -1;
}

.nav-right-dl2-box::after {
  position: absolute;
  top: -7.1px;
  left: 50%;
  transform: translateX(-50%);
  content: '';
  width: 0;
  height: 0;
  border-bottom: 8px solid rgba(108, 120, 155, 0.74);
  border-right: 5px solid transparent;
  border-left: 5px solid transparent;
  box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.1);
}

.dl2-box-title {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  font-weight: 550;
  padding: 0 24px 0 43px;
}

.nav-right-dl2-box .active1,
.active2 {
  padding: 0 0 0 19px;
}

.header .center {
  padding-top: 225px;
  display: flex;
  justify-content: center;
  position: relative;
  z-index: 1;
}

.header-center-div {
  text-align: center;
}

.header-center-h1 {
  margin-bottom: 41px;
  font-size: 63px;
  /* font-size: 84px; */
  font-weight: bold;
  color: #ffffff;
  line-height: 104px;
  letter-spacing: 9px;
  font-family: AlibabaPuHuiTi-Bold, AlibabaPuHuiTi;
}

.header-center-line {
  position: absolute;
  left: 50%;
  width: 762px;
  border: 1px solid;
  text-align: center;
  transform: translateX(-50%);
  border-image: linear-gradient(
      90deg,
      rgba(255, 166, 3, 0),
      rgba(255, 166, 3, 1),
      rgba(255, 166, 3, 0)
    )
    3 3;
}

.header-center-p {
  margin-top: 110px;
  font-size: 24px;
  /* font-size: 32px; */
  font-weight: 600;
  color: #ffffff;
  letter-spacing: 27px;
  font-family: PingFangSC-Regular, PingFang SC;
  opacity: 0.8;
  letter-spacing: 36px;
}

.header .bottom-container {
  position: absolute;
  bottom: 0;
  /* background-color: red; */
  background: rgba(255, 255, 255, 0.19);
  width: 100%;
  height: 135px;
  z-index: 10;
}

.header .bottom {
  position: absolute;
  display: flex;
  justify-content: center;
  bottom: 0;
  left: 50%;
  transform: translate(-50%);
  /* width: 1180px; */
  width: 1470px;
  height: 135px;
  /* background: rgba(255, 255, 255, 0.19); */
}

.header-bottom-div {
  width: 1260px;
  display: flex;
  /* justify-content: space-between; */
  /* background-color: green; */
  /* justify-content: space-around; */
}

.bottom-div-title {
  display: flex;
  align-items: center;
  position: relative;
  justify-content: center;
  width: 33.33%;
}

.bottom-div-title1 {
  display: flex;
  overflow: hidden;
}

.bottom-div-title1 h1 {
  animation: box 0.5s linear forwards;
  transform: translateY(50px);
  font-size: 38px;
  font-weight: 700;
  color: #ffb100;
  line-height: 44px;
  letter-spacing: 2px;
  text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.5);
}

.bottom-div-title1 span {
  margin-top: 13px;
  font-size: 24px;
  font-weight: 700;
  color: #ffffff;
  line-height: 25px;
  letter-spacing: 2px;
}
.bottom-div-title1 .yearText {
  font-size: 18px;
}

.bottom-div-title2 {
  margin-top: 5px;
  font-size: 15px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 700;
  color: #ffffff;
  line-height: 21px;
  letter-spacing: 2px;
}

.bottom-div-title:not(:last-child)::after {
  content: '';
  display: inline-block;
  width: 1px;
  height: 100%;
  background-color: #54606e;
  position: absolute;
  top: 0;
  right: 0;
}

.footer {
  display: flex;
  justify-content: center;
  width: 100%;
  background: #030e2c;
}

.footer-center {
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 1560px;
  height: 116px;
}

.footer-center p {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
}

.container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  /* background-color: lightcyan; */
}

.content {
  width: 100%;
  text-align: center;
}

.content-main1 {
  margin: 0 auto;
  width: 945px;
  position: relative;
  /* height: 717px; */
}

.content-main1-background {
  position: absolute;
  top: 90px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 150px;
  font-family: Arial-BoldMT, Arial;
  font-weight: normal;
  color: #fafafa;
  line-height: 173px;
  white-space: nowrap;
  letter-spacing: 5px;
  z-index: -1;
}

.content-main1-title {
  padding-top: 146px;
  font-size: 38px;
  font-family: AlibabaPuHuiTiB;
  color: #140047;
  line-height: 39px;
  letter-spacing: 2px;
}

.content-main1-p {
  width: 945px;
  height: 71px;
  margin-top: 25px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #140047;
  line-height: 34px;
  letter-spacing: 1px;
}

.content-main1-br {
  margin-top: 75px;
  /* width: 100%; */
  width: 956px;
  height: 1px;
  border: 1px solid #e8ebec;
  background-color: #e8ebec;
}

.content-main1-div {
  display: flex;
  justify-content: space-between;
  margin-top: 74px;
  height: 310px;
}

.img1 {
  width: 63px;
  height: 45px;
}

.img2 {
  width: 55px;
  height: 45px;
}

.img3 {
  width: 59px;
  height: 45px;
}

.content-main1-hexagon {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* width: 200px;
  height: 233px; */
  width: 200px;
  height: 240px;
  /* height: 100%; */
  background: url(../assets/img/six.png);
  background-size: cover;
  transition: transform 0.3s;
}

.content-main1-hexagon:hover {
  transform: translateY(-10px);
}

.content-main1-hexagon p {
  margin-top: 18px;
  font-size: 15px;
  font-weight: 400;
  color: #16171b;
  letter-spacing: 2px;
}

.content-main2 {
  position: relative;
  width: 100%;
  height: 870px;
  /* height: 780px; */
  height: 1080px;
  background-color: #f1f4fb;
  /* background-color:blue; */
  display: flex;
  align-items: center;
}

.leftbgc {
  width: 50%;
  height: 123px;
  background-color: #fff;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
}

.content-main2-content {
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  margin: 0 auto;
  /* width: 1182px; */
  width: 1470px;
  height: 100%;
  /* background-color: gray; */
}

.content-main2-title {
  height: 123px;
  font-size: 29px;
  font-family: AlibabaPuHuiTiB;
  color: #140047;
  line-height: 123px;
  letter-spacing: 2px;
  background-color: #fff;
  /* width: 100%; */
  width: 240px;
  text-align: left;
  position: relative;
  z-index: 1;
  margin-left: 10px;
}

.content-main2-right {
  flex: 1;
  /* width: 930px; */
  display: flex;
  justify-content: space-between;
}

.content-main2-right-div {
  position: relative;
  /* width: 435px; */
  /* height: 669px; */
  background-color: #ffffff;
  box-shadow: 0px 1px 10px 0px rgba(206, 206, 206, 0.5);
  text-align: start;
  padding-bottom: 30px;
  width: 580px;
}

.content-main2-right-div:nth-child(1) {
  margin-right: 68px;
}

.content-main2-right-img {
  width: 100%;
  /* height: 490px; */
  height: 666px;
  width: 100%;
}

.content-main2-right-title {
  position: absolute;
  top: 60px;
  right: 0;
  /* width: 170px; */
  padding: 0 20px;
  height: 44px;
  background-color: rgba(59, 94, 127, 0.9);
  text-align: center;
  font-size: 24px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 44px;
  letter-spacing: 2px;
  text-shadow: 0px 1px 10px rgba(206, 206, 206, 0.5), 0px 0px 2px #172a56;
}

.content-main2-right-p {
  padding: 30px 44px 0px 30px;
  text-align: start;
  /* font-size: 15px; */
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.7);
  line-height: 27px;
  letter-spacing: 1px;
  text-shadow: 0px 1px 10px rgba(206, 206, 206, 0.5);
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.content-main2-right-button {
  transition: transform 0.3s;
  display: flex;
  margin-top: 24px;
  margin-left: 30px;
  /* justify-content: center; */
  justify-content: space-between;
  align-items: center;
  width: 150px;
  height: 39px;
  background: rgba(255, 255, 255, 0.2);
  box-shadow: 0px 1px 10px 0px rgba(206, 206, 206, 0.5);
  border-radius: 3px;
  border: 1px solid #140047;
}

.content-main2-right-button span {
  /* margin-right: 18px; */
  /* font-size: 14px; */
  padding-left: 20px;
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #140047;
  text-shadow: 0px 1px 10px rgba(206, 206, 206, 0.5);
}

.content-main3 {
  position: relative;
  margin: 0 auto;
  width: 100%;
  height: 100%;
  /* top: 92px; */
  padding: 122px 0 155px;
  background-color: #fff;
}

.content-main3-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: start;
  margin: 0 auto;
  /* width: 1180px; */
  width: 1470px;
  /* height: 946px; */
  height: 1100px;
  /* background-color: antiquewhite; */
}

.content-main3-background1 {
  position: absolute;
  top: 156px;
  /* font-size: 180px; */
  font-size: 160px;
  font-family: Arial-BoldMT, Arial;
  font-weight: normal;
  color: #fafafa;
  line-height: 155px;
  letter-spacing: -7px;
  z-index: 0;
}

.content-main3-background2 {
  /* position: absolute;
  top: 480px;
  top: 0;
  transform: translateY(-50%);
  right: 0;
  width: 54%;
  height: 825px; */
  position: absolute;
  top: 122px;
  right: 0;
  width: 54%;
  height: 1100px;
  background-color: #f5f6fb;
  z-index: 1;
}

/* .content-main3-background3 {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0;
  width: 55%;
  height: 1100px;
  background: #e9edf6;
  z-index: -1;
} */

.content-main3-title {
  font-size: 29px;
  line-height: 39px;
  font-family: AlibabaPuHuiTiB;
  color: #140047;
  /* line-height: 52px; */
  letter-spacing: 2px;
}

.content-main3-nav {
  display: flex;
  margin: 37px 0 32px;
}

.content-main3-nav p {
  margin-right: 12px;
  /* width: 136px;
  height: 42px; */
  width: 120px;
  height: 32px;

  background: #efeff2;
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(29, 29, 29, 0.8);
  line-height: 32px;
  text-align: center;
  letter-spacing: 1px;
  transition: background-color 0.3s;
}

.content-main3-left {
  /* margin-top: -130px; */
  /* margin-top: -160px; */
  margin-top: -10px;
  margin-left: 10px;
  position: relative;
  z-index: 1;
}

.content-main3-left-div {
  overflow: hidden;
  /* width: 627px; */
  /* height: 510px; */
  width: 836px;
  /* height: 510px; */
  box-shadow: 0px 1px 24px 0px rgba(156, 168, 219, 0.4);
}

.content-main3-left-div img {
  width: 100%;
  /* height: 383px; */
  height: 510px;
  background-color: #172a56;
  object-fit: cover;
}

.main3-news {
  display: flex;
  align-items: center;
  overflow: hidden;
  background: #ffffff;
  cursor: pointer;
  transition: box-shadow 0.3s;
}

.main3-news-date {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 27px;
  /* padding: 35px 27px 0px 27px; */
  /* height: 128px; */
  height: 170px;
  border-right: 1px solid #ecf0f2;
}

.main3-news-date h1 {
  font-size: 36px;
  font-family: DINAlternate-Bold, DINAlternate;
  font-weight: bold;
  color: #1d1d1d;
  line-height: 32px;
  letter-spacing: 2px;
}

.main3-news-date p {
  margin-top: 8px;
  margin-bottom: 2px;
  font-size: 12px;
  white-space: nowrap;
  font-family: DINAlternate-Bold, DINAlternate;
  font-weight: bold;
  color: rgba(29, 29, 29, 0.22);
  letter-spacing: 1px;
}

.main3-news-date .bottom-line {
  width: 13px;
  height: 2px;
  background: #ffa200;
}

.main3-news-title {
  margin-left: 31px;
}

.main3-news-title h3 {
  /* width: 460px; */
  width: 580px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 16px;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1d1e20;
  line-height: 25px;
  letter-spacing: 1px;
}

.main3-news-title p {
  width: 500px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(29, 29, 29, 0.44);
  line-height: 15px;
  letter-spacing: 1px;
}
.main3-news-title .oneContent {
  /* width: 580px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(29, 29, 29, 0.44);
  line-height: 16px;
  height: 16px;
  letter-spacing: 1px; */
  width: 500px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(29, 29, 29, 0.44);
  line-height: 20px;
  letter-spacing: 1px;
}

.content-main3-right {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  height: 570px;
  /* margin-top: -64px; */
  margin-top: -116px;
  margin-left: 27px;
  /* background-color:red; */
  width: 100%;
  z-index: 2;
}

.newslist-container {
  width: 100%;
}

.content-main3-right .main3-news-title p {
  width: 375px;
}

.content-main3-right .main3-news {
  /* width: 516px; */
  /* height: 128px; */
  width: 100%;
  height: 170px;
  background: #ffffff;
  box-shadow: 0px 1px 10px 0px rgba(176, 183, 213, 0.2);
  margin: 10px 0;
}

body .content-main3 .content-main3-nav .active {
  color: #ffffff;
  background-color: #140047;
}

/* hover */
.nav-right-dl-title {
  opacity: 0.8;
  transition: all 0.3s;
}

.nav-right dl:hover .nav-right-dl-title {
  transform: scale(1.2);
  opacity: 1;
}

.nav-right-dl1:hover .nav-right-dl1-box,
.nav-right-dl2:hover .nav-right-dl2-box {
  visibility: visible;
  opacity: 1;
  z-index: 1;
}

.nav-right-dl1:hover img,
.nav-right-dl2:hover img {
  transform: rotate(0);
}

.dl1-box-title:hover,
.dl2-box-title:hover {
  background-color: rgba(11, 32, 97, 0.44);
  color: #ffffff;
}

.content-main2-right-button:hover {
  cursor: pointer;
  transform: translateX(10px);
}

.content-main3-nav p:hover {
  cursor: pointer;
  background-color: #140047;
  color: #ffffff;
}

.content-main3-right .main3-news h3 {
  width: 338px;
}

.content-main3-right .main3-news:hover {
  box-shadow: 0px 1px 10px 0px rgba(176, 183, 213, 1);
}
</style>



// WEBPACK FOOTER //
// src/components/webindex.vue